export default "__VITE_ASSET__CKT3j4kg__"